export default __webpack_public_path__ + "static/media/futura-book.9eebfa71.otf";